import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';

export const ImagePath = {
  [PlanTypes.Plan]: 'assets/backupFile.svg',
  [PlanTypes.RestorePlan]: 'assets/file-restore.svg',
  [PlanTypes.DataBasePlan]: 'assets/sqlbackup.svg',
  [PlanTypes.RestoreDataBasePlan]: 'assets/sqlrestore.svg',
  [PlanTypes.RestoreDatabaseFilesPlan]: 'assets/sqlrestore.svg',
  [PlanTypes.BackupVMware]: 'assets/vmware.svg',
  [PlanTypes.RestoreVMware]: 'assets/restore-vmware.svg',
  [PlanTypes.BackupHyperV]: 'assets/hyper-v.svg',
  [PlanTypes.RestoreHyperV]: 'assets/restore-hyper-v.svg',
  [PlanTypes.BackupDiskImagePlan]: 'assets/ibb.svg',
  [PlanTypes.RestoreDiskImagePlan]: 'assets/ibb-restore.svg',
  [PlanTypes.CloudVMBackupEC2Plan]: 'assets/ec2backup.svg',
  [PlanTypes.RestoreVMwareToCustom]: 'assets/restore-vmware.svg',
  [PlanTypes.RestoreHyperVToCustom]: 'assets/restore-hyper-v.svg',
  [PlanTypes.BackupProxmox]: 'assets/backup-proxmox.svg',
  [PlanTypes.RestoreProxmox]: 'assets/restore-proxmox.svg'
};

export interface PlanNameStepValue {
  Name: string;
  SavePlanInCloud?: boolean;
  blockLevel?: boolean;
  valid: boolean;
}
